module.exports = __webpack_public_path__ + "img/PORT11.94108e0f.jpg";